import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IMapModalHeaderProps {
  testId?: string;
  title: string;
}

/** Шапка модалки с картой — как у полноэкранной галереи: название над всем содержимым. */
export function MapModalHeader({ testId, title }: IMapModalHeaderProps): React.JSX.Element {
  return (
    <div className={styles['container']} data-testid={testId}>
      <div className={styles['title']}>
        <Body1 fontWeight="700">{title}</Body1>
      </div>
    </div>
  );
}
